import { useEffect } from 'react';
import { Divider, List, ListSubheader, ListItemText, Box, CircularProgress, ListItemButton, ListItemIcon } from '@mui/material';
import { Link } from 'react-router-dom';
import { useTheme } from '@mui/styles';
import { useDispatch, useSelector } from 'react-redux';

import { selectGenreOrCategory } from '../../features/currentGenreOrCategory';
import { useGetGenresQuery } from '../../services/TMDB';
import useStyles from './styles';
import genreIcons from '../../assets/genres';

const categories = [
  { label: 'Popular', value: 'popular' },
  { label: 'Top Rated', value: 'top_rated' },
  { label: 'Upcoming', value: 'upcoming' },
];

const redLogo = 'https://fontmeme.com/permalink/210930/8531c658a743debe1e1aa1a2fc82006e.png';
const blueLogo = 'https://fontmeme.com/permalink/210930/6854ae5c7f76597cf8680e48a2c8a50a.png';

const Sidebar = ({ setMobileOpen }) => {
  // NOTE { genreIdOrCategoryName } = useSelector((state) => state.currentGenreOrCategory) is also possible
  // NOTE currentGenreOrCategory is from the store, and the genreIdOrCategoryName state is from currentGenreOrCategory.js
  const currentGenreOrCategory = useSelector((state) => state.genreOrCategory.genreIdOrCategoryName);
  const theme = useTheme();
  const classes = useStyles();
  const { data, isFetching } = useGetGenresQuery();
  const dispatch = useDispatch();

  useEffect(() => {
    setMobileOpen(false);
  }, [currentGenreOrCategory]);

  return (
    <>
      <Link to="/" className={classes.imageLink}>
        <img
          className={classes.image}
          src={theme.palette.mode === 'light' ? redLogo : blueLogo}
          alt="Filmpire logo"
        />
      </Link>
      <Divider />
      <List>
        <ListSubheader>Categories</ListSubheader>
        {/* Not using "{}" because we want to return instantly */}
        {categories.map(({ label, value }) => (
          <Link key={value} className={classes.links} to="/">
            <ListItemButton onClick={() => dispatch(selectGenreOrCategory(value))}>
              <ListItemIcon>
                {/* ES6 Object Literal Property value shorthand => genreIcons[name.toLowerCase()] */}
                <img src={genreIcons[label.toLowerCase()]} alt="Filmpire logo" className={classes.genreImages} height={30} />
              </ListItemIcon>
              <ListItemText primary={label} />
            </ListItemButton>
          </Link>
        ))}
      </List>
      <Divider />
      <List>
        <ListSubheader>Genres</ListSubheader>
        {/* Not using "{}" because we want to return instantly */}
        {isFetching ? (
          <Box display="flex" justifyContent="center">
            <CircularProgress />
          </Box>
        ) : data?.genres.map(({ name, id }) => (
          <Link key={name} className={classes.links} to="/">
            <ListItemButton onClick={() => dispatch(selectGenreOrCategory(id))}>
              <ListItemIcon>
                {/* ES6 Object Literal Property value shorthand => genreIcons[name.toLowerCase()] */}
                <img src={genreIcons[name.toLowerCase()]} alt="Gere Icon" className={classes.genreImages} height={30} />
              </ListItemIcon>
              <ListItemText primary={name} />
            </ListItemButton>
          </Link>
        ))}
      </List>
      <Divider />
    </>
  );
};
export default Sidebar;

